import React, {useContext, useState} from 'react';
import {Select, Input, Form, InputNumber, Button} from "antd";
import {internalApi} from "../../common/axios";
import {DIALOG_KEY} from "../../shared/utils/enum";
import toast from "react-hot-toast";
import duration from 'dayjs/plugin/duration';
import dayjs from "dayjs";
import {buildUrl} from "../../shared/utils/net";
import {ShopPackageEntity} from "./ShopPackageEntity";
import {CancelButton, CopyButton, DeleteButton, SaveButton} from "../../shared/components/buttons/CustomButtons";
import DateStepper from "../../shared/components/date/DateStepper";
import CustomDateTimePicker from "../../shared/components/date/CustomDateTimePicker";
import {AuthContext} from "../../shared/contexts/authContext";
import {useShopPackage, useShopPackageGroup} from "../probability/useItemData";

dayjs.extend(duration);

const getNameList = (target, index, shopPackageGroup, shopPackage) => {
    return Object.values(shopPackageGroup[target])
        .filter((group) => group.groupIdx === shopPackage[target][index]?.groupIdx)
        .map((group, index) => ({
            ...group,
            key: group.groupIdx + index,
        }));
}

const intervalUnitOptions = [
    { label: '시간', value: 'hour' },
    { label: '분', value: 'minute' },
    { label: '일', value: 'day' },
];

const SALE_TYPE = [
    { label: '0 (일반)', value: 0 },
    { label: '1 (패키지 할인)', value: 1 },
]

// 판매 타입은 DB 에 저장하지 않는다. maxBuyCount > 0 이면 '기간 내 횟수'.
const SALES_TYPE = { PERIOD: 'period', COUNT: 'count' };

const StoreManagerEditModal = ({record, handleClose, dialogRef, handleSetDialog}) => {
    const {currentUser} = useContext(AuthContext);
    const {data: shopPackage} = useShopPackage();
    const {data: shopPackageGroup} = useShopPackageGroup();

    const nameList = getNameList(currentUser.target, record.index, shopPackageGroup, shopPackage);

    const [row, setRow] = useState(new ShopPackageEntity({
        ...record,
        intervalValue: record.intervalValue || 1,
        intervalUnit: record.intervalUnit || 'hour',
    }));


    const handleSetRows = (key, value) => {
        setRow((prevState) => {
            const newState = {...prevState};
            newState[key] = value;
            return new ShopPackageEntity(newState);
        });
    }

    const isCountSale = row.maxBuyCount > 0;

    const handleSalesTypeChange = (type) => {
        setRow((prevState) => new ShopPackageEntity({
            ...prevState,
            maxBuyCount: type === SALES_TYPE.COUNT ? 1 : 0,
            coolTime: type === SALES_TYPE.COUNT ? 1 : 0,
        }));
    }

    const handleSave = async (e) => {
        e.preventDefault();

        if (row.isInvalidate()) return;

        await internalApi.post('store_manager', {id: row.index, data: row.toJson()}).then((res) => {
            toast.success(res.data.message);
            handleClose(true);
        }).catch((err) => {
            console.error(err);
            toast.error("저장 실패");
        });
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
    }

    const handleCopy = async (e) => {
        e.preventDefault();

        if (row.isInvalidate()) return;

        await internalApi.post('store_manager/copy', {data: row.toJson()}).then((res) => {
            toast.success(res.data.message);
            handleClose(true);
        }).catch((err) => {
            console.error(err);
            toast.error("저장 실패");
        });
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
    }

    const handleDelete = async (e) => {
        e.preventDefault();
        const currentDialog = dialogRef.current;  // ref에서 최신 상태 가져오기
        if (currentDialog.confirmText === 'DELETE') {
            await internalApi.delete(buildUrl('store_manager', {seq: row.seq})).then((res) => {
                toast.success(res.data.message);
                handleClose(true);
            }).catch((err) => {
                toast.error("삭제 실패");
                console.error(err);
            });

            handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
        } else {
            toast.error("잘못된 확인 문자입니다. DELETE 를 입력하세요.");
            handleSetDialog([{key: DIALOG_KEY.CONFIRM_TEXT, value: ''}]);
        }
    }

    const handleRegisterRepeatEvent = async (e) => {
        e.preventDefault();
        if (!row.intervalValue || row.intervalValue <= 0) {
            toast.error('반복 판매 간격을 올바르게 입력하세요.');
            return;
        }
        if (!row.intervalUnit) {
            toast.error('반복 판매 간격 단위를 선택하세요.');
            return;
        }
        try {
            const res = await internalApi.post('store_manager/repeat', {data :{
                ...row.toJson(),
                intervalValue: row.intervalValue,
                intervalUnit: row.intervalUnit,
            }});
            toast.success(res.data.message || '반복 이벤트 등록 완료');
            handleClose(true);
        } catch (err) {
            console.error(err);
            toast.error('반복 이벤트 등록 실패');
        }
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
    };

    return (
        <div>
            <div style={{ marginTop: 26 }}>
                <Form layout="inline">
                    <Form.Item label="패키지 이름" style={{marginBottom: 8, width: '35%'}}>
                        <Input
                            name={"packageName"}
                            value={row.packageName}
                            onChange={(e) => handleSetRows('packageName', e.target.value)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item style={{ width: '35%', marginLeft: '1%' }}>
                        <Select
                            placeholder="타이틀을 선택하세요."
                            onChange={(e) => handleSetRows('packageName', e)}
                            size="small"
                            className="name-select"
                            showSearch
                            optionLabelProp="label"
                            value={row.packageName}
                        >
                            {nameList.map((option, index) => (
                                <Select.Option
                                    key={index}
                                    value={option.nameText}
                                    label={option.nameText}
                                >
                                    <div>
                                        <div style={{ fontSize: '11px', color: '#999' }}>
                                            ID: {option.index}
                                        </div>
                                        <div style={{ fontWeight: 'bold' }}>
                                            {option.nameText}
                                        </div>
                                    </div>
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="OnOff" style={{marginBottom: 8, marginLeft: 8, width: '15%'}}>
                        <Select
                            value={row.onOff}
                            onChange={(value) => handleSetRows('onOff', value)}
                            size="small"
                        >
                            <Select.Option value={1}>On</Select.Option>
                            <Select.Option value={0}>Off</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="패키지 운영시간" style={{marginBottom: 8, width: '40%'}}>
                        <Input
                            type="number"
                            name={"packageTime"}
                            value={row.packageTime}
                            onChange={(e) => handleSetRows('packageTime', e.target.value < 0 ? 0 : e.target.value)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item label="반복 판매 간격" style={{marginBottom: 8, width: '40%'}}>
                        <InputNumber
                            min={1}
                            value={row.intervalValue}
                            onChange={val => handleSetRows('intervalValue', val)}
                            size="small"
                            style={{ width: '60%' }}
                        />
                        <Select
                            value={row.intervalUnit}
                            onChange={val => handleSetRows('intervalUnit', val)}
                            size="small"
                            style={{ width: '38%', marginLeft: '2%' }}
                        >
                            {intervalUnitOptions.map(opt => (
                                <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="할인 타입" style={{marginBottom: 8, width: '45%'}}>
                        <Select
                            value={row.saleType}
                            onChange={val => handleSetRows('saleType', val)}
                            size="small"
                            style={{ width: '100%', marginLeft: '2%' }}
                        >
                            {SALE_TYPE.map(opt => (
                                <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="판매 타입" style={{marginBottom: 8, width: '45%'}}>
                        <Select
                            value={isCountSale ? SALES_TYPE.COUNT : SALES_TYPE.PERIOD}
                            onChange={handleSalesTypeChange}
                            size="small"
                            style={{ width: '100%' }}
                        >
                            <Select.Option value={SALES_TYPE.PERIOD}>기간 내 (1회)</Select.Option>
                            <Select.Option value={SALES_TYPE.COUNT}>기간 내 횟수</Select.Option>
                        </Select>
                    </Form.Item>
                    {isCountSale && (
                        <>
                            <Form.Item label="최대 구매 횟수" style={{marginBottom: 8, width: '45%'}}>
                                <InputNumber
                                    min={1}
                                    precision={0}
                                    value={row.maxBuyCount}
                                    onChange={val => handleSetRows('maxBuyCount', Math.max(1, val || 1))}
                                    size="small"
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="재구매 쿨타임(분)"
                                style={{marginBottom: 8, width: '45%'}}
                                validateStatus={row.coolTime === 0 ? 'warning' : ''}
                                help={row.coolTime === 0 ? '0분이면 구매 직후 바로 다시 노출됩니다.' : undefined}
                            >
                                <InputNumber
                                    min={0}
                                    precision={0}
                                    value={row.coolTime}
                                    onChange={val => handleSetRows('coolTime', val || 0)}
                                    size="small"
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </>
                    )}
                    <Form.Item label="메모" style={{marginBottom: 8, width: '45%'}}>
                        <Input
                            name={"memo"}
                            value={row.memo}
                            onChange={(e) => handleSetRows('memo', e.target.value)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item label="최소 적용 버전" style={{width: '50%'}}>
                        <Input
                            value={shopPackage[currentUser.target][row.index]?.openVersion || ''}
                            style={{width: '100%'}}
                            size="small"
                            disabled={true}
                        />
                    </Form.Item>
                </Form>
            </div>
            <CustomDateTimePicker rows={row} handleSetRows={handleSetRows} hasAdd={false}/>
            <DateStepper setRows={setRow} entity={ShopPackageEntity}/>
            <div className={"event-edit-buttons"}>
                <Button type="dashed" onClick={handleRegisterRepeatEvent} style={{marginRight: 8}}>
                    반복 상품 등록
                </Button>
                <CopyButton onClick={handleCopy} handleSetDialog={handleSetDialog}/>
                <SaveButton onClick={handleSave} handleSetDialog={handleSetDialog}/>
                <CancelButton onClick={handleClose}/>
                <DeleteButton onClick={handleDelete} handleSetDialog={handleSetDialog} display={false}/>
            </div>
        </div>
    );
}

export default StoreManagerEditModal;
